import { api } from "@/api/client";
import type { components } from "@/api/contract";
import { unwrap } from "@/api/errors";

/** The current user. Chat needs `plan_id` to gate web search to paid plans. */
type Me = components["schemas"]["MeResponse"];

/** GET /v1/me — current user; the bearer token is attached by client middleware. */
export async function getMe(): Promise<Me> {
  return unwrap(await api.GET("/v1/me"));
}
